export const isLocal = false;
export const host = isLocal ? "http://localhost" : "https://api.tenitx.com/notics-tracer";